import axios from 'axios'

export default {
  async fetchSuppliers({ commit }) {
    try {
      const response = await axios.get('/api/suppliers')
      commit('SET_SUPPLIERS', response.data.suppliers || [])
    } catch (error) {
      console.error('Error fetching suppliers:', error)
      // Set default suppliers if API fails
      commit('SET_SUPPLIERS', [
        { id: 1, name: 'Reece' },
        { id: 2, name: 'Bunnings' },
        { id: 3, name: 'Mitre 10' },
        { id: 4, name: 'Other' }
      ])
    }
  }
}
